import { render, staticRenderFns } from "./LicitacaoFornecedorProposta.vue?vue&type=template&id=2cea5a02"
import script from "./LicitacaoFornecedorProposta.vue?vue&type=script&lang=js"
export * from "./LicitacaoFornecedorProposta.vue?vue&type=script&lang=js"
import style0 from "./LicitacaoFornecedorProposta.vue?vue&type=style&index=0&id=2cea5a02&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports